import React from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Table, Spinner } from 'react-bootstrap';
import ImageRenderer from './ImageRenderer';
import EVALink from 'components/pages/glass-management/EVALink';
import dayjs from 'dayjs';
import { getCaseInsensitiveObjVal } from 'helpers/utils';

const AdvanceTable = ({
  getTableProps,
  headers,
  headerGroups,
  page,
  prepareRow,
  headerClassName,
  rowClassName,
  tableProps,
  tableRef,
  style,
  handleClickRow,
  renderExpandedRow,
  loading = false,
  beSortOption = {},
  expandedRowIndex,
  setExpandedRowIndex,
  setExpandedRowData,
  expandedRowData
}) => {
  const countColumn = headerGroups
    .map(x => x.headers.length)
    .reduce((acc, curr) => acc + curr, 0);

  const cellRenderer = (cell) => {
    switch (cell?.column?.type) {
      case 'image':
        return <ImageRenderer value={cell.value} />;
      case 'ccf-odr-link':
        return <EVALink ccf={getCaseInsensitiveObjVal(cell?.row?.original, 'ccfid')} odr={getCaseInsensitiveObjVal(cell?.row?.original, 'odrid')} value={cell.value} />;
      case 'date':
        return dayjs(cell.value).format('DD/MM/YYYY');
      case 'datetime':
        try { return dayjs(cell.value).format('DD/MM/YYYY HH:mm:ss'); }
        catch { return cell.render('Cell'); }
      default:
        return cell.render('Cell');
    }
  }

  return (
    <div>
      {/* <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="outline-secondary" onClick={() => {
          try {
            const cols = headers || [];
            const headerNames = cols.map(c => (typeof c.Header === 'string' ? c.Header : (c.accessor || c.id || '')));

            const rows = (page || []).map(r => {
              // ensure row is prepared so r.cells is populated
              try { prepareRow && prepareRow(r); } catch (err) { console.error(err) }
              return (r.cells || []).map(cell => {
                const colType = cell?.column?.type;
                let val = cell?.value;
                switch (colType) {
                  case 'image':
                    return '';
                  case 'ccf-odr-link':
                    return val ?? '';
                  case 'date':
                    return val ? dayjs(val).format('DD/MM/YYYY') : '';
                  case 'datetime':
                    try { return val ? dayjs(val).format('DD/MM/YYYY HH:mm:ss') : ''; } catch { return String(val ?? ''); }
                  default:
                    if (val === null || val === undefined) return '';
                    if (typeof val === 'object') return JSON.stringify(val);
                    return String(val);
                }
              });
            });

            const csvContent = [headerNames, ...rows].map(e => e.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'export.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Export failed', err);
          }
        }}>Export to Excel</Button>
      </div> */}
      <SimpleBarReact>
        <Table {...getTableProps(tableProps)} ref={tableRef} style={style}>
          <thead className={headerClassName}>
            {headerGroups.map((group, i) => (
              <tr
                key={'k' + i}
                {...group.getHeaderGroupProps()}
              >
                {group.headers.map((column, j) => (
                  <th
                    style={{ position: 'fixed', top: 0 }}
                    key={'hearder' + j}
                    {...column.getHeaderProps(
                      column.getSortByToggleProps(column.headerProps)
                    )}
                    onClick={
                      beSortOption.handleSort
                        ? () => beSortOption.handleSort(column)
                        : column.getSortByToggleProps().onClick
                    }
                  >
                    {column.render('Header')}
                    {beSortOption.canSort ? (
                      column.isBeSorted ? (
                        column.isBeSortedDesc ? (
                          <span className="sort desc" />
                        ) : (
                          <span className="sort asc" />
                        )
                      ) : (
                        <span className="sort" />
                      )
                    ) : column.canSort ? (
                      column.isSorted ? (
                        column.isSortedDesc ? (
                          <span className="sort desc" />
                        ) : (
                          <span className="sort asc" />
                        )
                      ) : (
                        <span className="sort" />
                      )
                    ) : (
                      ''
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {loading && [
              <tr key="table-row-loading" className="text-center">
                <td colSpan={countColumn > 0 ? countColumn : headers.length}>
                  <Spinner
                    variant="primary"
                    animation="border"
                    role="status"
                  ></Spinner>
                </td>
              </tr>
            ]}
            {page &&
              page.length > 0 &&
              !loading &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <React.Fragment key={'row-fragment-' + i}>
                    <tr key={'r' + i}
                      className={rowClassName}
                      {...row.getRowProps({
                        onClick: (e) =>
                          handleClickRow(
                            e,
                            row,
                            setExpandedRowIndex,
                            expandedRowIndex,
                            setExpandedRowData
                          )
                      })}
                    >
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps(cell.column.cellProps)}
                        >
                          {cellRenderer(cell)}
                        </td>
                      ))}
                    </tr>

                    {expandedRowIndex === row.index && renderExpandedRow && (
                      <tr>
                        <td colSpan={row.cells.length}>
                          {expandedRowData[row.id] ? (
                            renderExpandedRow(expandedRowData[row.id])
                          ) : (
                            <div>Loading...</div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            {page &&
              !page.length &&
              !loading &&
              <tr key="table-row-empty" className="text-center">
                <td colSpan={countColumn > 0 ? countColumn : headers.length}>
                  No Results
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </SimpleBarReact>
    </div>
  );
};
AdvanceTable.propTypes = {
  getTableProps: PropTypes.func,
  headers: PropTypes.array,
  page: PropTypes.array,
  prepareRow: PropTypes.func,
  headerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  tableProps: PropTypes.object,
  loading: PropTypes.bool,
  headerGroups: PropTypes.array,
  style: PropTypes.object,
  handleClickRow: PropTypes.func,
  tableRef: PropTypes.object,
  renderExpandedRow: PropTypes.any,
  expandedRowIndex: PropTypes.number,
  setExpandedRowIndex: PropTypes.func,
  setExpandedRowData: PropTypes.func,
  expandedRowData: PropTypes.object,
  beSortOption: PropTypes.object
};

export default AdvanceTable;
